import {
  Box,
  Button,
  CurrencyInput,
  Form,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Input,
  Spacer,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { format } from 'date-fns'
import { defineMessages, useIntl } from 'react-intl'
import { HomeownerDigestTrackingEventLocation } from '../../../../constants/tracking'
import { SlideOnMount } from '../../../shared/Animations'
import { Step } from '../types'

const MSG = defineMessages({
  heading: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.heading',
    defaultMessage: 'How about purchase details?'
  },
  subheading: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.subheading',
    defaultMessage: "Homebot needs this to confirm your property's purchase history."
  },
  submit: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.submit',
    defaultMessage: 'Continue'
  },
  priceLabel: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.priceLabel',
    defaultMessage: 'Purchase Price'
  },
  priceRequiredError: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.priceRequiredError',
    defaultMessage: "Enter your home's purchase price"
  },
  dateLabel: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.dateLabel',
    defaultMessage: 'Purchase Date'
  },
  dateRequiredError: {
    id: 'HomePriceIndexWizard.steps.purchaseDetails.dateRequiredError',
    defaultMessage: "Enter your home's purchase date"
  }
})

const Slide = props => <SlideOnMount interval={50} top='-80px' {...props} />

export const PurchaseDetails = ({ onComplete }: Step) => {
  const intl = useIntl()
  const today = format(new Date(), 'yyyy-MM-dd')

  return (
    <Form onSubmit={onComplete} flex='1' display='flex' flexDirection='column' justifyContent='space-between'>
      {({ formState: { errors } }) => (
        <>
          <Slide>
            <Heading fontWeight='normal' mb='2'>
              {intl.formatMessage(MSG.heading)}
            </Heading>
            <Text mb='0'>{intl.formatMessage(MSG.subheading)}</Text>
          </Slide>
          <Slide>
            <Box marginTop='12'>
              <FormControl isInvalid={!!errors?.soldPrice}>
                <FormLabel>{intl.formatMessage(MSG.priceLabel)}</FormLabel>
                <CurrencyInput
                  name='soldPrice'
                  rules={{
                    required: {
                      value: true,
                      message: intl.formatMessage(MSG.priceRequiredError)
                    }
                  }}
                  tracking={{
                    guid: 'ozsc2epUcJZMYRMyBEdumi',
                    descriptor: MSG.priceLabel.defaultMessage,
                    ui_context:
                      HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_PURCHASE_DETAILS_STEP
                  }}
                />
                <FormErrorMessage>{errors?.soldPrice?.message?.toString()}</FormErrorMessage>
              </FormControl>
              <FormControl isInvalid={!!errors?.soldDate}>
                <FormLabel>{intl.formatMessage(MSG.dateLabel)}</FormLabel>
                <Input
                  type='date'
                  max={today}
                  name='soldDate'
                  rules={{
                    required: {
                      value: true,
                      message: intl.formatMessage(MSG.dateRequiredError)
                    }
                  }}
                  tracking={{
                    guid: 'nXnuLhELZY6MpFYKcVsEyT',
                    descriptor: MSG.dateLabel.defaultMessage,
                    ui_context:
                      HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_PURCHASE_DETAILS_STEP
                  }}
                />
                <FormErrorMessage>{errors?.soldDate?.message?.toString()}</FormErrorMessage>
              </FormControl>
            </Box>
          </Slide>
          <Spacer />
          <Slide>
            <Button
              type='submit'
              colorScheme='primary'
              width='100%'
              tracking={{
                guid: '9NBc9stw9jGCdCkFzw7FMJ',
                descriptor: MSG.submit.defaultMessage,
                ui_context:
                  HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_PURCHASE_DETAILS_STEP
              }}
            >
              {intl.formatMessage(MSG.submit)}
            </Button>
          </Slide>
        </>
      )}
    </Form>
  )
}
